module Elma.Bindings {

    export class LimitInput {
        
        public update(element: any, valueAccessor: () => number, allBindingsAccessor?: KnockoutAllBindingsAccessor) {
            // MAKE inputs limited to a certain number of chars
            // limitValue decides how many chars a user can submit
            var limitValue = ko.unwrap(valueAccessor());
            element.onkeypress = function () {
                element.value = element.value.substr(0, limitValue);
            }
        }

    }

    ko.bindingHandlers['limitInput'] = new LimitInput();

}